import { type LoggedUser, UserManagment } from '@justomx/webview-commons'
import type { CommonHeaders } from 'types/commons/model'
import { checkProperJWT } from 'utils/checkJWT'

export const getUser = () => {
  let user: LoggedUser | undefined
  try {
    user = UserManagment.getCurrentUser()
  } catch {
    user = undefined
  }

  if (user?.authorizationWms && checkProperJWT(user.authorizationWms)) {
    return user
  }

  throw new Error(
    'Autorización inválida (¿estás intentando acceder desde Atlas-wms?).'
  )
}

export const getCurrentCountry = (): string => {
  const user = getUser()
  return user.country?.toUpperCase()
}

export const getCurrentWarehouse = (): string => {
  const user = getUser()
  return user.warehouse?.toUpperCase()
}

export const getCommonHeaders = (): CommonHeaders => {
  const user = getUser()

  return {
    'x-hardcoded': false,
    authorization: `Bearer ${user.authorizationWms}`,
    'x-authorization-wms': `Bearer ${user.authorizationWms}`,
    'x-authorization-core': `Bearer ${user.authorizationCore}`,
    'x-justo-country': user.country?.toUpperCase(),
    'x-justo-warehouse': user.warehouse?.toUpperCase()
  }
}
